import {ReactElement} from "react";
import {RendererProps} from "../RendererProps";
import {ensureNotObject} from "../common";


export function RenderCreateUpdateRenovationCostCategory(props: RendererProps): ReactElement {
    const vars = props.variables;
    const id = vars["id"];
    const budgetYear = vars["budgetYear"];
    const name = vars["name"];
    return <ul>
        {id && <li>Id: {ensureNotObject(id)}</li>}
        <li>Budget Year: {ensureNotObject(budgetYear)}</li>
        <li>Name: {ensureNotObject(name)}</li>
    </ul>;
}